export enum RequestFuelFormNames {
	truckReg = 'truckReg',
	amount = 'amount',
	fuelingPoint = 'fuelingPoint',
	fuelType = 'fuelType',
	origin = 'origin',
	destination = 'destination',
	date = 'date',
}
